import useAppStore from '../store/useAppStore'

const useAppEnvironment = () => {
  const authMode = useAppStore((state) => state.authMode)
  const runtimeEnvironment = useAppStore((state) => state.runtimeEnvironment)

  return {
    authMode,
    runtimeEnvironment,
    isTelegramMiniApp: runtimeEnvironment === 'telegram',
    isWebBrowser: runtimeEnvironment === 'browser',
    isDevelopment: authMode === 'development'
  }
}

export default useAppEnvironment
